import React, { useMemo, FC } from 'react'
import { PolaroidList } from 'components/SA/Polaroid'
import ListConnector, { ConnectorProps as ListProps } from '../connectors/List'
import styles from './CuratedDeals.module.scss'
import Price from './Price'

const ArtworkPolaroidList: FC<ListProps> = ({
  algoliaIndice,
  algoliaUserToken,
  artworks,
  isReady,
  isSet,
  userID,
  isUsersArtworksAccount,
  promoCode,
  pdpHash,
}) => {
  const customPriceElement = (artwork) => <Price artwork={artwork} />
  const artworksWithCustomPDPUrl = useMemo(() => {
    return artworks.map((artwork) => ({
      ...artwork,
      printUrl: `${artwork.printUrl}?curatedDeals=${pdpHash}`,
      productUrl: `${artwork.productUrl}?curatedDeals=${pdpHash}`,
    }))
  }, [artworks])
  return (
    <div className={styles.artworkPolaroidList}>
      <PolaroidList
        algoliaIndice={algoliaIndice}
        algoliaUserToken={algoliaUserToken}
        eventType='curated-deals-artworks'
        dataApi='algolia'
        dataList='curated-deals-artworks'
        dataListId='curated-deals-artworks'
        dataListName={`Curated Deals Artworks`}
        artworks={artworksWithCustomPDPUrl}
        isLoading={!isReady || !isSet}
        isArtistNameVisible={true}
        userID={userID}
        isMediumMaterialVisible={false}
        isUsersArtworksAccount={isUsersArtworksAccount}
        customStyle={styles.customPolaroidListContainer}
        customPriceElement={customPriceElement}
        customPromoCode={promoCode}
      />
    </div>
  )
}

export default ListConnector(ArtworkPolaroidList)
